import React from "react";

const Privacy = (props: any) => {
  return (
    <iframe title="Privacy" width="100%" height="100%" src="https://docs.google.com/document/d/e/2PACX-1vQPAjvYkgdrx3_k5Kkek1GKJ3jZYgZwdPCreYVnYpYwgojFjscp6QpYB-xaIjI0AtpA9PRXIOwZKWXb/pub?embedded=true"></iframe>
  );
};

export default Privacy;